import { Grid } from "@mui/material";
import { CottageOutlined } from '@mui/icons-material';
import { useEffect } from 'react';

import { useUser } from '../userContext/UserContext';
import { useAparts } from "../apartsContext/ApartsContext";

import TitleBar from "../titleBar/TitleBar";
import { ApartmentCard } from "./ApartmentCard";
import { getGroupedAparts } from "./ApartmentsHelpers";

const Apartments = () => {
  // console.log('render Apartments')

  const { user, userName, getCurrentUser } = useUser();
  const { apartList, getApartList } = useAparts();

  useEffect(() => {
    getCurrentUser();
  }, [])

  useEffect(() => {
    const userId = user ? user.id : null
    getApartList(userId)
  }, [])

  function renderItems(arr) {
    const { boilerGroups, regularAparts } = getGroupedAparts(arr);

    // Отрисовываем группы котлов
    const boilerCards = Object.entries(boilerGroups).map(([programId, group]) => (
      <ApartmentCard
        key={`boiler-program-${programId}`}
        item={group[0]}
        boilerAparts={group}
      />
    ));

    // Отрисовываем обычные апарты
    const regularCards = regularAparts.map(item => (
      <ApartmentCard key={item.id} item={item} />
    ));

    return (
      <>
        {boilerCards}
        {regularCards}
      </>
    );
  }

  const content = apartList ? renderItems(apartList) : null;

  return (
    <>
      <TitleBar
        icon={<CottageOutlined color="primary" fontSize="large" sx={{ mr: 2 }} />}
        title={userName}
      />
      <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
        {content}
      </Grid>
    </>
  )
}

export default Apartments;